import { render, staticRenderFns } from "./CValidation.vue?vue&type=template&id=36f4d016&"
import script from "./CValidation.vue?vue&type=script&lang=js&"
export * from "./CValidation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports